import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './ListItem.styles.js';

var defaultProps = {};
var ListItemPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      icon = props.icon,
      iconColor = props.iconColor,
      value = props.value;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement("li", {
    id: id,
    value: value
  }, icon && /*#__PURE__*/React.createElement(IconPresentation, {
    icon: icon,
    size: "small",
    color: iconColor,
    noMargin: true,
    title: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(hostClass, "-text")
  }, children)), icon && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-icon__spacing")
  }));
}, defaultProps);

export { ListItemPresentation, defaultProps };
